export enum UiOfferType {
    Energy = 'energy',
    EnergyTransfer = 'energy-transfer',
    Telecom = 'telecom',
    TelecomTransfer = 'telecom-transfer',
    Water = 'water',
}
